module.exports = __webpack_public_path__ + "img/arrow-forward-outline.ab56fd19.svg";